import { render } from "./EmailVerificationSuccess.vue?vue&type=template&id=35a37128&scoped=true"
import script from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"
export * from "./EmailVerificationSuccess.vue?vue&type=script&lang=js"

import "./EmailVerificationSuccess.vue?vue&type=style&index=0&id=35a37128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a37128"]])

export default __exports__